var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"upload-icon",class:_vm.customizedClass !== '' && 'customizedClass',attrs:{"viewBox":"0 0 1024 1024","fill":_vm.color}},[_c('path',{attrs:{"d":"M512 598q108 0 225 47t117 123v86h-684v-86q0-76 117-123t225-47zM512 512q-70 0-120-50t-50-120 50-121 120-51 120 51 50 121-50 120-120 50z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }